import React, { useMemo } from "react";
import {
  SFHeroCard,
  SFHeroTile,
  SFDetailTile,
  SFClientSideFilterActions,
  getUtcDateTime,
} from "@sf-core";
import _ from "lodash";
import { Logger } from "@base-provider";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { GRID_NAMES } from "../../../../constants/gridNames";

const RecentlyProgressedCard = ({ skills, actions }) => {
  const { t } = useTranslation();
  const sixWeeksAgo = moment().subtract(6, "weeks");
  const nextDay = moment().add(1, "days");
  const dispatch = useDispatch();
  const state = "positive";
  const type = "inRange";

  const savedLayout = useSelector((state) => {
    return state.clientSideFilter.find(
      (clientSideFilter) =>
        clientSideFilter.gridName === GRID_NAMES.DASHBOARD_MY_SKILLS
    );
  });

  const recentlyProgressedNumber = useMemo(() => {
    let count = _.filter(skills, (skill) =>
      moment(skill.lastProgressedDate).isAfter(sixWeeksAgo)
    ).length;
    return count;
  }, [skills]);

  const onClick = () => {
    let currentFilterModel = savedLayout?.state?.filter?.filterModel || [];
    const payload = {
      gridName: GRID_NAMES.DASHBOARD_MY_SKILLS,
      state: {
        filter: {
          filterModel: {
            ...currentFilterModel,
            lastProgressedDate: {
              type: type,
              dateFrom: getUtcDateTime(sixWeeksAgo),
              dateTo: getUtcDateTime(nextDay),
            },
          },
        },
      },
    };
    dispatch(SFClientSideFilterActions.saveState(payload));
  };

  Logger.of("App.RecentlyProgressedCard").info(recentlyProgressedNumber);

  return (
    <SFHeroCard
      actions={actions}
      leftContent={
        <SFHeroTile
          title={recentlyProgressedNumber}
          subTitle={t("dashboardScreen.recentlyProgressedCard.title")}
          state={state}
        />
      }
    >
      <div onClick={() => onClick()}>
        <SFDetailTile
          title={t("dashboardScreen.recentlyProgressedCard.detail.title")}
          subTitle={
            recentlyProgressedNumber > 0
              ? t("dashboardScreen.recentlyProgressedCard.detail.subTitle")
              : t(
                "dashboardScreen.recentlyProgressedCard.detail.subTitleNoProgress"
              )
          }
        />
      </div>
    </SFHeroCard>
  );
};

export default RecentlyProgressedCard;
